exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-352c3f76] {\n    font-size: 38px;\n    line-height: 50px;\n    margin-bottom: 15px;\n    font-weight: 700;\n    color: black;\n    letter-spacing: 1px;\n    margin-top: 0;\n}\n.emoticon[data-v-352c3f76] {\n  margin-right: 15px;\n}\n@media only screen and (max-width: 575px) {\nh2[data-v-352c3f76] {\n        font-size: 29px;\n        line-height: 45px;\n}\n}\n", ""]);

// exports
